<div class="flex flex-row justify-between items-center py-2">
  <div class="flex flex-col">
    <label for="lotteryEnabled">New lottery messages</label>
    <p class="text-sm text-surface-500 m-0 mt-1">Get notified when new lotteries you qualify for opens or is about to close.</p>
  </div>
  <p-toggleswitch inputId="lotteryEnabled"
                  [disabled]="disabled()"
                  class="flex"
                  [ngModel]="lotteryEnabled()"
                  (onChange)="onLotteryChange($event.checked)"/>
</div>
<p-divider class="p-0 m-0"/>
<div class="flex flex-row justify-between items-center py-2">
  <div class="flex flex-col">
    <label for="lotteryFollowupEnabled">Follow-up on submitted applications</label>
    <p class="text-sm text-surface-500 m-0 mt-1">Receive updates about submitted applications during the entire selection process.</p>
  </div>
  <p-toggleswitch inputId="lotteryFollowupEnabled"
                  [disabled]="disabled()"
                  class="flex"
                  [ngModel]="lotteryFollowupEnabled()"
                  (onChange)="onLotteryFollowupChange($event.checked)"/>
</div>
<p-divider class="p-0 m-0"/>
<div class="flex flex-row justify-between items-center py-2">
  <div class="flex flex-col">
    <label for="promotionalEnabled">Non-lottery related messages</label>
    <p class="text-sm text-surface-500 m-0 mt-1">Special offers & other info.</p>
  </div>
  <p-toggleswitch inputId="promotionalEnabled"
                  [disabled]="disabled()"
                  class="flex"
                  [ngModel]="promotionalEnabled()"
                  (onChange)="onPromotionalChange($event.checked)"/>
</div>
